import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "../../../../../shared/components/index";
import { Log } from "ng2-logger";
import { FormType } from "@app/tool/details/components/form-type.enum";

import * as _ from 'lodash';
import { DescriptionFormComponent } from "@app/tool/details/components/forms/description-form/description-form.component";
import { Tool } from "@app/tool/model/tool.model";
import { User } from "@app/shared/models";
import { UserService } from "@services/user.service";

@Component({
    selector: 'app-description-form-modal',
    templateUrl: './description-form-modal.component.html',
    styleUrls: ['./description-form-modal.component.scss']
})
export class DescriptionFormModalComponent {
    _logger = Log.create(DescriptionFormModalComponent.name);

    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;
    @ViewChild(DescriptionFormComponent, {static: false}) lifecycleForm: DescriptionFormComponent;

    @Input() tool: Tool;
    @Input() owners: User[];
    @Input() isLoading: boolean;

    @Output() updateDescription = new EventEmitter<any>();

    showValidations = false;

    constructor(private userService: UserService) {
    }

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.reset();
    }

    clickUpdate() {
        if (!this.isFormValid()) {
            this._logger.info('clickEquipmentUpdate:: Form is invalid');
            return;
        }
        this.isLoading = true;
        let description = this.lifecycleForm.value();
        this._logger.info('clickUpdate:: Description', description);
        description = Object.assign(description, description.storage);
        description.ownerId = description.owner.id;
        delete description.owner;

        this.updateDescription.emit({
            type: FormType.DESCRIPTION,
            details: _(description).omitBy(_.isNil).omitBy(_.isNaN).value()
        });
    }

    private reset() {
        this.showValidations = false;

        if (this.lifecycleForm) {
            this.lifecycleForm.reset();
        }
        this.modal.close();
    }

    private isFormValid() {
        this.showValidations = true;
        return this.lifecycleForm.isFormValid();
    }

}
